import React, { Component } from 'react';
import { Container, Grid, Segment, Header } from 'semantic-ui-react';

import { connect } from 'react-redux';

import ClaimSubmissionSelector from '../../component/claim/submission_selector';
import ClaimSubmissionStep from '../../component/claim/submission_step';
import ClaimSubmissionInformation from '../../component/claim/submission_information';
import ClaimSubmissionConfirm from '../../component/claim/submission_confirm';
import {
    submitFlexClaim,
    submitInpatientClaim,
    getInpatientClaimOptions,
    getClaimOptionsEclaim,
    submitOutpatientClaim,
    getAppLaunchConfigFromMHC,
    getClaimUserPlanConfigBenefit,
    setCompanyClaimOption,
    setClaimantClaimOption,
    setVisitDateClaimOption,
    getEclaimOptionsPageAction,
    getClaimOptionsRequest
} from '../../actions';

class SubmitClaimPage extends Component {
    state = {
        type: null,
        stepIndex: 1,
        claimData: null
    }

    componentDidMount() {
        // this.props.getInpatientClaimOptions(this.props.user.accessToken);
        this.fetchClaimOption()
    }

    componentDidUpdate(prevProps) {
        const { contactNoVerified } = prevProps;
        if (contactNoVerified !== this.props.contactNoVerified) {
            this.fetchClaimOption();
        }
    }

    fetchClaimOption() {
        const { accessToken, uuid, nric } = this.props.user;
        const companyId = this.props.claimFilterOptions.filterByCompany ? this.props.claimFilterOptions.filterByCompany : this.props.user.companies[0].companyId

        this.props.getClaimOptionsEclaim(accessToken, companyId);
        this.props.getClaimUserPlanConfigBenefit({ accessToken, companyId: this.props.user.companyId });
        this.props.getAppLaunchConfigFromMHC();
        setCompanyClaimOption(companyId);
        setClaimantClaimOption(nric);
        setVisitDateClaimOption(null);
    }

    updateTypeSelector(type) {
        this.setState({type, stepIndex: 2});
    }

    updateCompletedClaimData(claimData) {
        this.setState({claimData, stepIndex: 3});
    }

    renderStep() {
        if (this.state.stepIndex === 1) {
            return <ClaimSubmissionSelector updateTypeSelector={this.updateTypeSelector.bind(this)} claimOptions={this.props.claimOptions} configBenefit={this.props.configBenefit} />;
        } else if (this.state.stepIndex === 2) {
            return (
                <ClaimSubmissionInformation
                    type={this.state.type}
                    user={this.props.user}
                    submitFlexClaim={this.props.submitFlexClaim}
                    submitInpatientClaim={this.props.submitInpatientClaim}
                    claimOptions={this.props.claimOptions}
                    submitOutpatientClaim={this.props.submitOutpatientClaim}
                    updateCompletedClaimData={this.updateCompletedClaimData.bind(this)}
                    configBenefit={this.props.configBenefit}
                    appLaunchConfig={this.props.appLaunchConfig}
                    getClaimOptionsEclaim={this.props.getClaimOptionsEclaim}
                    getEclaimOptionsPageAction={this.props.getEclaimOptionsPageAction}
                    getClaimOptionsRequest={this.props.getClaimOptionsRequest}
                    isLoaded={this.props.isLoaded}
                />
            );
        } else if (this.state.stepIndex === 3) {
            return (
                <ClaimSubmissionConfirm
                    claimType={this.state.type}
                    submitOutpatientClaim={this.props.submitOutpatientClaim}
                    submitInpatientClaim={this.props.submitInpatientClaim}
                    claimData={this.state.claimData}
                    appLaunch={this.props.appLaunch}
                />
            );
        }
    }

    render() {
        return (
            <Container fluid>
                <Segment attached="top">
                    <Header>Submit Claim</Header>
                </Segment>
                <ClaimSubmissionStep
                    stepIndex={this.state.stepIndex}
                    setIndex={(index) => this.setState({stepIndex: index})} />
                <Segment attached>
                    <Grid>
                        {this.renderStep()}
                    </Grid>
                </Segment>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user.user,
        configBenefit: state.user.configBenefit,
        claimOptions: state.claimOptions,
        appLaunchConfig: state.appLaunchConfig,
        contactNoVerified: state.otp.contactNoVerified,
        claimFilterOptions: state.claims.filterOptions,
        appLaunch : state.appLaunchConfig,
        isLoaded: state.claims.isLoaded,

    };
}

export default connect(mapStateToProps, {
    submitFlexClaim,
    submitInpatientClaim,
    getInpatientClaimOptions,
    getClaimOptionsEclaim,
    submitOutpatientClaim,
    getAppLaunchConfigFromMHC,
    getClaimUserPlanConfigBenefit,
    getEclaimOptionsPageAction,
    getClaimOptionsRequest
})(SubmitClaimPage);
